export const GET_ITINERARY_BOARDING_REPORTS = 'GET_ITINERARY_BOARDING_REPORTS';
export const CLEAR_ITINERARY_BOARDING_REPORTS = 'CLEAR_ITINERARY_BOARDING_REPORTS';
export const FLAG_GETTING_ITINERARY_BOARDING_REPORTS = 'FLAG_GETTING_ITINERARY_BOARDING_REPORTS';